
import React from 'react'
import { withRouter } from 'react-router-dom'
import { compose } from 'recompose'
import { translate } from 'react-switch-lang'

import MyController from '../../core/components/MyController'
import ViewMyReservation from '../../views/event/ViewMyReservation'

import EventManager from '../../business/EventManager'

class MyReservationController extends MyController {
	constructor(props) {
		super(props)
		this.state.isLoading = false
		this.bEvent = new EventManager(this)
	}

	onGetEventCalendar = (userEmail, dateStr) => {
		return this.bEvent.getEventCalendar(userEmail, dateStr)
	}
	render() {
		return (
			<React.Fragment>
				{super.render()}
				<ViewMyReservation
					onGetEventCalendar={this.onGetEventCalendar}
				/>
			</React.Fragment>
		)
	}
}

const enhance = compose(
	translate,
	withRouter,
)


export default enhance(MyReservationController)